var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview"},[_c('span',[_vm._v("udf.register(\"")]),_vm._v(" "),_c('span',{staticClass:"preview-name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('span',[_vm._v("\", ")]),_vm._v(" "),_c('span',{staticClass:"preview-params"},[_vm._v(_vm._s(_vm.pyPara))]),_vm._v(" "),_c('span',[_vm._v(")")])])
}
var staticRenderFns = []

export { render, staticRenderFns }